import { environment } from './environment';

export const Constants = Object.freeze({
    api_root: environment.api + '/api/0.2',
    api_root_v3: `${environment.api}/api/v3`,
    user_api_root: `${environment.userApi}/api/v1`,
    company_name: 'SPORTLOGiQ',
    experimentalStorageKey: 'experimental_mode',
    impersonationOverrideStorageKey: 'override_impersonation_guard',
    timerMs: (typeof sessionStorage !== 'undefined' && +sessionStorage?.getItem('app_timer')) || (environment.production && 1 * 60000),
    maxRegularPeriod: 3,
    maxPlayableClips: 5000,
    zendeskHelpCenterExpirationTimeInMin: 3,
    return_to_zendesk: 'return_to',
    markerjs2Key: 'MJS2-F001-S959-5027',
    markerjsliveKey: 'MJSL-F990-S434-8667',
    tableauExpirationTimeInMs: 300000, // 5 mins
    defaultAnnotationDurationForExportInSeconds: 3, // 3 seconds
    maxExportedPlaylistDuration: 2700,
    /** When evaluating live game eligibility, this is the time offset in hours used for the window into the past */
    liveGamePastOffset: 4,
    /** When evaluating live game eligibility, this is the time offset in hours used for the window into the future */
    liveGameFutureOffset: 1
});

/* eslint-enable */

export const mediaQueryBreakPoints = {
    avgDesktopWidth: '(max-width: 1199px)',
};

// Default page size options for the mat-paginator
export const PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS = [15, 25, 50, 100, 250];
